import * as actions from '../../../actions/assessments/budget'
import * as h2Api from '../../../h2Api'

const initialState = {
  editingRecord: null,
  ...h2Api.handleRest()
}
const location = (state = initialState, action) => {
  switch (action.type) {
    case actions.SELECT_BUDGET_FOR_EDIT:
      return {
        ...state,
        editingRecord: action.budget
      }
    case actions.UPDATE_EDITING_NAME:
      return {
        ...state,
        editingRecord: {
          ...state.editingRecord,
          name: action.name
        }
      }
    case actions.UPDATE_SELECTED_RECORD:
      return {
        ...state,
        result: state.result.map(r => (r.id === action.record.id ? action.record : r)),
        editingRecord: null
      }
    case actions.LIST_BUDGETS:
      return {
        ...state,
        ...h2Api.handleRest(action)
      }

    default:
      return state
  }
}

export default location
